import React, { useState } from 'react';
import { SCREEN_WIDTH } from '../../Utils/Dimensions';
import { Logo } from "../../assets/icons";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from '../../Utils/url';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import {showToast} from '../../Components/Toast';



const certText = 'با مجوز رسمی از اتحادیه طلا و جواهر تهران'
const Login = () => {
    const dispatch = useDispatch();
    const [mobile, setMobile] = useState();
    const [password, setPassword] = useState();
    const [load, setLoad] = useState(false);
    const isLogin = useSelector(
        (state) => state.auth.isLogin
    )


    const submit = () => {
        setLoad(true);
        const body = {
            mobile,
            password
        }
        ApiCall(
            "POST",
            urls.login,
            body,
            'LoginData ->',
            null,
            (res) => {
                console.log('loginRes', res);
                dispatch({
                    type: "IS_LOGIN",
                    isLogin: true,
                    token: res.data.access_token
                })
                dispatch({
                    type: "INIT",
                    payload: res.data ? res.data : null
                })
            },
            (error) => {
                setLoad(false);
                showToast("عضویتی با مشخصات داده شده ثبت نشده است","error")
                console.log('error', error);
            }
        )

    }

    return (
        <div className='loginH'>
            <div className="addToHomeContainer">
                <div className="_logo">
                    <Logo width={SCREEN_WIDTH} height={SCREEN_WIDTH * 0.1} />
                </div>

                <form className="_userName">
                    <label className="_label" htmlFor="username">شماره موبایل خود را وارد کنید</label>
                    <input className="_input" id="username" name="username" placeholder="شماره موبایل" onChange={(event) => setMobile(event.target.value)} required></input>
                    <label className="_label2" htmlFor="pwd">کلمه عبور خود را وارد کنید</label>
                    <input className="_input" type="password" id="pwd" name="pwd" placeholder="کلمه عبور" onChange={(event) => setPassword(event.target.value)} required></input>
                </form>
                <div className="_div">
                    {!load ? <button className="_btn" onClick={submit}>ورود</button> : <div> <CircularProgress className="_circular" /> </div>}
                </div>
                {/* <div className="_infoBtn">
                    <hr />
                    <p >برای عضویت لطفا از ساعت  8 صبح لغایت 18 با شماره <a type="tel" href="tel:02188313100">02188313100</a> تماس بگیرید.</p>
                </div> */}
            </div>
        </div>
    )
}

export default Login;